import React from "react";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomButton from "../Custom/CustomButton";

const actionButtonSx = {
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: "#fff",
  color: "#374151",
  border: "1px solid #d1d5db",
  fontWeight: 500,
  fontSize: "0.875rem",
  px: 1.5,
  "&:hover": { backgroundColor: "#f9fafb", borderColor: "#9ca3af" },
};

const DashboardHeader = ({
  title = "Dashboard",
  subtitle,
  departments = [],
  selectedDepartmentId = "all",
  onDepartmentSelect,
  onTimePeriodClick,
  onTeamsClick,
  onExportClick,
}) => {
  return (
    <header className="dashboard-header">
      <div className="dashboard-header-top">
        <div className="dashboard-header-title-block">
          <h1 className="dashboard-header-title">{title}</h1>
          {subtitle ? <p className="dashboard-header-subtitle">{subtitle}</p> : null}
        </div>

        <div className="dashboard-header-actions">
          <CustomButton
            variant="outlined"
            color="inherit"
            size="small"
            fullWidth={false}
            className="dashboard-header-action-btn"
            startIcon={<CalendarTodayOutlinedIcon sx={{ fontSize: 16 }} />}
            endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />}
            onClick={onTimePeriodClick}
            sx={actionButtonSx}
          >
            Time Period
          </CustomButton>

          <CustomButton
            variant="outlined"
            color="inherit"
            size="small"
            fullWidth={false}
            className="dashboard-header-action-btn"
            startIcon={<GroupsOutlinedIcon sx={{ fontSize: 16 }} />}
            endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />}
            onClick={onTeamsClick}
            sx={actionButtonSx}
          >
            Teams
          </CustomButton>

          <CustomButton
            variant="outlined"
            color="inherit"
            size="small"
            fullWidth={false}
            className="dashboard-header-action-btn"
            startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 16 }} />}
            onClick={onExportClick}
            sx={actionButtonSx}
          >
            Export
          </CustomButton>
        </div>
      </div>

      {departments.length > 0 ? (
        <div className="dashboard-header-scope">
          <span className="dashboard-header-scope-label">Scope Departments:</span>
          <div className="dashboard-scope-chips" role="group" aria-label="Scope departments">
            {departments.map((dept) => {
              const isActive = dept.id === selectedDepartmentId;
              return (
                <button
                  key={dept.id}
                  type="button"
                  className={`dashboard-scope-chip${isActive ? " dashboard-scope-chip--active" : ""}`}
                  aria-pressed={isActive}
                  onClick={() => onDepartmentSelect?.(dept.id)}
                >
                  {dept.label}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </header>
  );
};

export default DashboardHeader;
